import Vue from 'vue'
import App from './App'
import router from './router'
import Buefy from 'buefy'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faMagic } from '@fortawesome/free-solid-svg-icons'
import { faFilm } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import Verte from 'verte';
import 'verte/dist/verte.css';
import VueRecaptcha from 'vue-recaptcha';
import VueGtag from "vue-gtag";
import LazyTube from "vue-lazytube";
import SocialSharing from "vue-social-sharing"
import Sticky from 'vue-sticky-directive'

Vue.config.devtools = true 

Vue.config.productionTip = false

Vue.use(SocialSharing)
Vue.use(Buefy)
Vue.use(LazyTube);
Vue.use(Sticky)

Vue.use(VueGtag, {
  config: { id: "G-GHV8C6YD01" }
});

library.add(faSpinner, faHome, faMagic, faFilm, faFacebook, faTwitter, faArrowRight)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component(VueCropper)
Vue.component('verte', Verte);
Vue.component(VueRecaptcha)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js